import styled from 'styled-components';
import { tablet768 } from '@nubank/nuds-web/styles/breakpoints';

import ImageBlock from 'components/structure/ImageBlock';
import { paddingBuilder } from 'styles/themeUtils';

const SectionImageBlock = styled(ImageBlock)`
  ${paddingBuilder.all(0)}
  width: 100%;

  ${tablet768`
    ${paddingBuilder.all(0)}
  `}
`;

SectionImageBlock.displayName = 'SectionImageBlock';

export default SectionImageBlock;
